<template>
    <div style="background:white; height:100%">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:80px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px; ">新增 </span></el-link>
                </div>
 
                <span style=" margin-left:5px;font-size:12px;margin-right:10px;">字段查询</span>
                <el-select v-model="selparam" size="small" placeholder="请选择列名" filterable  style="width:120px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N' "></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="inputQry" ></el-button>
                </el-input> 
                <el-select v-model="selparam2" size="small" placeholder="请选择列名" filterable  style="width:120px; " >
                    <span v-for="item in tabCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="inputQry" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="inputQry" ></el-button>
                </el-input>
                <div style=" font-size:12px;margin-left:5px;display:flex;width:120px">
                    <div style="font-size:12px;margin-right:4px;color:red">状态</div>
                    <el-select @change="inputQry" v-model="stfg_" size="small" style="width:90px">
                        <el-option label="所有记录" value="ALL"></el-option>
                        <el-option label="待确认" value="N"></el-option>

                        <el-option label="待审核" value="K"></el-option>
                        <el-option label="已审核" value="Y"></el-option>
                    </el-select> 
                </div>
            </div>
        </div>
        <el-table  :data="qcData" 
              border                            
              size="small"
              class="custom-table-border"
              :cell-style="{padding:'2px'}"
              v-loading="v_loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              :height="subHeight" 
              :row-key="getRowKey"
              ref="refreq"
              show-summary
              :summary-method="getSummary"
              highlight-current-row
              header-cell-class-name="clearPadding"
              :header-cell-style="{ 'color':'#389','text-align':'center'}"
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" width="60" fixed>
                <el-table-column label="序号" type="index" width="60" fixed>
                    <template slot="header"  >
                        <el-link   @click="rowShow" style="font-size:12px;color:#fff"> 
                            <el-tooltip content=" 清除条件" effect="light">
                                <i class="iconfont icon-shanchu1" style="color:#409eff"></i>
                            </el-tooltip>
                        </el-link>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column   v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align"  show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>      
                        <el-select v-else-if="item.key=='FEETYNM'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <span v-for="item in tyArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.CNAME"></el-option>
                            </span>
                        </el-select>
                        <el-select v-else-if="item.key=='RCVMTHNM'" @change="inputQry" v-model="v_row[item.key]" size="mini" placeholder="请选择" filterable clearable style="width:100%; " >
                            <span v-for="item in rcvArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.CNAME"></el-option>
                            </span>
                        </el-select>
                        <el-select v-model="v_row[item.key]" v-else-if="item.key=='STFG'" clearable  size="mini" @change="inputQry" style="width:100%">
                            <el-option label="未审核" value="N"></el-option>
                            <el-option label="已审核" value="Y"></el-option>
                        </el-select>
                        <el-input type="number" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;font-size:11px ">{{scope.row[item.key]}}</div> </el-link>
                        <el-checkbox v-else-if="item.edcss=='checkbox'" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <el-link v-else-if="item.key=='PAYPATH'||item.key=='IMGPATH'" :underline="false" > 
                            <div v-if="scope.row[item.key] && scope.row[item.key].lastIndexOf('.pdf')>-1 ">
                                <div @click="pdfViewer(scope.row[item.key])" slot="error"><i class="iconfont icon-pdf"></i></div>
                            </div>
                            <el-image v-else style="width:100%;height:20px;" :src="scope.row[item.key]" :preview-src-list="[scope.row[item.key]]">                 
                                <div   slot="error" ><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </el-link>
                        <el-tag  size="small" v-else-if="item.key=='STFG' && scope.row['STFG']=='Y'" type="success" effect="dark">已审核</el-tag>
                        <el-tag  size="small" v-else-if="item.key=='STFG' && scope.row['STFG']!=='Y'" type="danger" effect="dark">未审核</el-tag>
                        <el-tag  size="small" v-else-if="item.key=='FEETYNM' && scope.row['FEETY']=='426026'" type="warning" effect="dark">{{scope.row['FEETYNM']}}</el-tag>
                        <el-tag size="small"  v-else-if="item.key=='FEETYNM' && scope.row['FEETY']=='426027'" type="success" effect="dark">{{scope.row['FEETYNM']}}</el-tag>
                        <el-tag size="small" v-else-if="item.key=='FEETYNM' && scope.row['FEETY']=='426028'" type="danger" effect="dark">{{scope.row['FEETYNM']}}</el-tag>
                        <el-tag size="small" v-else-if="item.key=='FEETYNM' && scope.row['FEETY']=='430497'" type="info" effect="dark">{{scope.row['FEETYNM']}}</el-tag>
                        <el-tag size="small" v-else-if="item.key=='FEETYNM'" type="" effect="dark">{{scope.row['FEETYNM']}}</el-tag>
                        
                        <span v-else v-text="scope.row[item.key]" ></span>
                    </template>
                </el-table-column>                
            </el-table-column> 
             <el-table-column
                fixed="right"
                label="状态操作"
                align="center"
                width="215">
                <template slot-scope="scope">
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                    <el-link  @click="editRec(scope.row,'Y',scope.$index)" :underline="false" style="font-size:10px;margin-right:5px; "><span style="font-size:12px;margin-right:5px">查看</span></el-link> 
                    <span v-if="scope.row['STFG']=='N'" > 
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="editRec(scope.row,'N',scope.$index)" :underline="false" style="font-size:10px;margin-right:5px; "><span style="font-size:12px;margin-right:5px">编辑</span></el-link> 
                    </span>
                    <span v-if="scope.row.STFG==='N' " >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="appBool" @click="stfgRec(scope.row,'K',scope.$index,'确认')" :underline="false"  ><span style="font-size:11px;margin-right:5px;">确认</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='K' " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="appBool" @click="stfgRec(scope.row,'N',scope.$index,'弃认')" :underline="false"  ><span style="font-size:11px;margin-right:5px;">弃认</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y' " >
                        <i class="iconfont icon-renminbi" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="payBool" @click="attBtn(scope.row, scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">付款</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG=='K' " >
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'Y',scope.$index,'审核')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">审核</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y' &&!scope.row['PAYDTTM'] " >
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="cfmBool" @click="stfgRec(scope.row,'N',scope.$index,'弃审')" :underline="false"  ><span style="font-size:12px;margin-right:5px;">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row['STFG']=='N'" > 
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:2px;"></i>
                        <el-link  @click="stfgRec(scope.row,'X',scope.$index,'作废')" :underline="false" style="font-size:10px; "><span style="font-size:12px;">作废</span></el-link> 
                    </span>
                </template>
            </el-table-column>  
        </el-table>
        <!-- 分页查询 -->
        <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">确定</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >   
                    <div class="one-toolbar">
                        <span class="spanRow"> {{gpitem.gpnm}} </span>
                    </div>        
                    <Form :model="mainRow" :label-width="gpitem.gpnm=='注意事项'?160:120"  label-position="right" inline  :rules="ruleValidate">  
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem  :label="item.title"  :class=" item.EDCSS=='textarea'?'item-one':'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">                  
                                <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>   
                                <el-checkbox size="medium" :disabled="saveFlag" border v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox> 
                                <el-select size="medium" filterable clearable :disabled="item.DISABLED==='Y'?true:false||saveFlag" v-else-if="item.EDCSS==='select'" v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-option v-for="(item,index) in comboArr[item.FLDNO]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                                </el-select>
                                <el-input size="medium" :disabled="saveFlag" v-else-if="item.EDCSS==='button'" v-model="mainRow[item.FLDNO]"  @focus="inputBtn('','',item.FLDNO)" style="width:100%;border:1px solid #778898"></el-input>
                                <el-select size="medium" filterable @change="empChg" v-else-if="item.key==='EMPNM' " v-model="mainRow[item.FLDNO]"   style="width:100%">
                                    <el-row v-for="(item ,index) in empArr " :key="index">
                                        <el-col :span="4">
                                            <el-option  :label="item.TY" :value="item.EMPNM"></el-option>
                                        </el-col>
                                        <el-col :span="10">
                                            <el-option  :label="item.DEPTNM" :value="item.EMPNM"></el-option>
                                        </el-col>
                                        <el-col :span="10">
                                            <el-option  :label="item.EMPNM" :value="item.EMPNM"></el-option>
                                        </el-col>
                                    </el-row>
                                </el-select>
                                <el-input resize="none" :disabled="saveFlag" v-else-if="item.EDCSS==='textarea'" type="textarea" :rows="4"  placeholder="请输入内容" v-model="mainRow[item.FLDNO]" maxlength="1500" show-word-limit ></el-input>
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-toolbar">
                    <span class="spanRow"> 上传垫付截图</span>
                </div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :with-credentials="true"                            
                        :format="['jpg','jpeg','png','pdf' ]"
                        :max-size="4196"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :disabled="saveFlag"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex; "  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> 删除</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
 
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
 
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">取消</el-button>
                    <el-button :disabled="addBool||saveFlag"  type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">保存</el-button>
                </span>
            </div>
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:v_cond ="t_cond" v-bind:tabCol ="tableCol" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>

        <el-dialog  v-dialogDrag   :visible.sync="editWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-edit v-bind:tabCol ="tableCol" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="editWin=false" @child-sure="btnSure"></pub-edit>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="attWin" width="500px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">上传付款图片</span>
            </div> 
 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">付款日期</div>
                <el-input size="medium" disabled v-model="v_rowrec['PAYDTTM']" style="width:100%;font-size:12px"> </el-input>
            </div> 
            <div style="line-height:35px;font-size:12px;display:flex;margin-top:10px">
                <div style="width:100px;font-size:14px; ">付款人 </div>
                <el-input size="medium" disabled v-model="v_rowrec['PAYER']" style="width:100%;font-size:14px"> </el-input>
            </div> 
            <div style="border-left:3px solid #409eff;line-height:30px;background:#ccc;margin-bottom:5px;margin-top:15px">
                <span style="padding-left:5px;font-size:12px;font-weight:600"> 付款附件 </span>
            </div> 
            <Upload
                ref="upload"
                name="upfile"
                :data="uploadData"
                :show-upload-list="false"
                :before-upload="beforeImgFile"
                :on-success="successAttFile"
                :with-credentials="true"                            
                :format="['jpg','jpeg','png','pdf' ]"
                :max-size="4096"
                :on-format-error="handleFormatError"
                :on-exceeded-size="handleMaxSize"
                type="drag"
                :on-progress="handleProgress"
                :action="uploadUrl"
                v-if="fileUrl.length<2"
                style="display: inline-block;width:200px; ">                           
                <div style="padding: 1px 0;width:200px;height:200px;">
                    <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                    <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                </div>                                                       
            </Upload> 
            <div  v-if="fileUrl.length>2" >
                <div v-if="fileUrl.lastIndexOf('.pdf')>-1" style="width:200px;height:200px;border:1px solid #e8eaec;overflow-y:hidden">
                    <iframe :src="fileUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
                </div>
                <el-image v-else-if="fileUrl.length>2"  :preview-src-list="[fileUrl]" fit="fill"  style="width:200px;height:200px;margin-right:30px;" :src="fileUrl"></el-image>
                <div style="height:25px;background:#e8eaec;width:200px; display:flex;justify-content:space-between">
                    <el-link  :underline="false" @click="attDel(fileUrl)"><Icon type="md-close" /> 删除</el-link>
                    <el-link v-if="fileUrl.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(fileUrl)"><Icon type="ios-search" /> 预览</el-link>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;margin-top:10px ">
                <span style="float:right">
                    <el-button type="info" @click="attWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button type="primary" @click="attSave" size="small" style="margin-left:30px" icon="iconfont icon-chenggong"> 确认</el-button>
                </span>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import pubWin from '../datamgt/pubwin.vue'  
import repWin from '../datamgt/repWin.vue' 
import pubEdit from '../datamgt/pubmulti.vue'  
export default {
    name:'project_fee',
    data () {
        return {
            fileUrl:'N',
            attWin:false,
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            toolFlag:false,
            qryCond:'',
            stfg_:'K' ,
            dtlRow:{},
            v_tabRow:{},
            v_tabIndex:'',
            chkIndex: 0,
            stfgBool:true,
            rcvArr:[],
            v_commit :true,
            promptWin:false,
            v_row:{},
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            formArr:[],
            rowDtl:{},
            btnWin:false,
            t_cond:'',
            editWin:false,
 
            delDtlArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            selparam:'IDNO',
            txtparam:'',
            mainRow:{},
            prdFlag:'create',
            goPage:'',
            empArr:[],
            qcData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            appBool:false, //确认权限
            payBool:false, //下推权限
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany', //api请求路径
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            selparam2:'',
            txtparam2:'',
            oper2:'like',
            dataCount:0,
            rowSize:50,
            hrCol:[],
            matCol:[],
            tabCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            v_key:'',
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            comboArr:[],
            tyArr:[],
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            repWin:false,
            repUrl:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            v_random:'',
            v_admin:this.$cookies.get('v_admin') , 
            v_formurl:'xuper_auth/getFormGroup', 
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            fileName:'',
            uploadUrl:'xuper_auth/uploadImg' ,
            Accept: "png,jpg,jpeg,gif,tiff,pdf",
            delImg:[],
            prodCol:[],
            v_rowrec:{},
        }
    },
    components: {
      pubWin,  
      repWin,
      pubEdit
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 155) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 385) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 140) + 'px';
        },
    },
    mounted () {
        //收款方式
        getBaseData('xuper_auth/getBaseData','PARENTNO','15563','','','v_sys_base','').then(res=>{
            this.rcvArr =res.result
        }) 
        
        //表单资料分组 
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','426023','gpnm,gpsort','','lstseq','1', ' order by gpsort').then((res) => {
            this.formArr = res.result             
        })
        //操作符
        getBaseData('xuper_auth/getBaseData','PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        }) 
        getBaseData('xuper_auth/getBaseData','PARENTNO','426025','','','v_sys_base','').then(res=>{
            this.tyArr =res.result
        }) 
        getBaseData('xuper_auth/getBaseData'+'','userno',this.v_username,'frmidseq','426023','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        getBaseData('xuper_auth/getBaseData'+'','corpid',this.v_corpid,'','','V_FEE_EMP','').then(res=>{
            this.empArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','426023','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISEXP==='N'){ //确认
                    this.appBool=true
                }if (row.ISEXCEL==='N'){ //下推
                    this.payBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','426023','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.inputQry('') //询价单主数据   
            this.comSelect() 
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        //对指定列进行合计
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =this.allList.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='AMT'){
                    let v_sum =values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) )
                        }else{
                            return prev
                        }
                    },'')
                    if (v_sum){
                        sums[index] =v_sum.toLocaleString()
                    }else{
                        sums[index]=''
                    }
                }
            })
            return sums
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.inputQry()
        } ,
        //字段查询
        inputQry(){
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.tabCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.txtparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.txtparam+'\''
                }
            }
            if (this.selparam2&& this.txtparam2){ //列1
                if (this.oper2==='like'){
                    cond_=cond_+' and  '+this.selparam2+'  like  \'%' + this.txtparam2+'%\' '
                }else{
                    cond_=cond_+' and  '+this.selparam2  +this.oper2+' \''+this.txtparam2+'\' '
                }
            }
            if (this.stfg_ =='K'){
                cond_= cond_ + 'and stfg !=\'Y\''
            }else if (this.stfg_ =='ALL'){
                //
            }else{
               cond_= cond_ + 'and stfg  =\''+ this.stfg_+'\''
            }
            this.getQryList(v_cond+cond_)
        },
        // 附件保存
        attSave(){
            this.$confirm('确定要保存吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{    
                let v_path =this.fileUrl=='N'?'':this.fileUrl  
                let v_cond=' set paypath=\''+v_path+'\',payer=\''+this.v_usernm +'\',paydttm=\''+getDate('full')+'\' '
                let v_table='sku_fee'
                this.$axios({
                    method: 'post',
                    url: 'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:this.v_row['IDSEQ'], p_table:v_table,p_cond:v_cond},
                }).then(res=>{ 
                    if (res.code!='200'){
                        this.promptWin =true
                        this.prompt =res.result
                    }else{
                        this.attWin=false
                        this.inputQry()
                    }
                })
            }).catch(err=>{})
        },
        //
        attDel(filePath){
            if (filePath)
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.fileUrl='N' 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/deleteFile',
                    data: {p_value: filePath},
                })       
            }).catch(()=>{})
        },
        attBtn(row,index){
            this.v_rowrec =JSON.parse(JSON.stringify(row))
            if (row['PAYPATH']){
                this.fileUrl =row['PAYPATH']
            }        
            this.attWin =true
        },
         //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(idseq,lstseq,path,index){
            this.$confirm('你确定要删除此附件吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,FILEPATH:path}) 
                this.imgData.splice(index, 1);    
            }).catch(()=>{})
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择pdf或图片格式'
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + ' 文件太大, 不能超出4M' 
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            let v_filename='/assets/basedict/'+this.fileName+file.name.substring(file.name.lastIndexOf('.'))
            this.imgData.push({FILEPATH:v_filename})                   
        },
        successAttFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            let v_filename='/assets/basedict/'+this.fileName+file.name.substring(file.name.lastIndexOf('.'))
            this.fileUrl =v_filename                   
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= this.v_username+getDate('year')+'-FE'     
            this.uploadData = {
                code: this.fileName ,
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 

        },
 
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        empChg(val){
            console.log(val)
            this.mainRow['DEPTNM']=''
            this.mainRow['BANKNO']=''
            this.mainRow['BANKNM']=''
            this.mainRow['EMPNO']=''
            this.empArr.some(item=>{
                if(item['EMPNM']==val){
                    this.mainRow['DEPTNM']=item['DEPTNM']

                    this.mainRow['BANKNO']=item['BANKNO']
                    this.mainRow['BANKNM']=item['BANKNM']
                    this.mainRow['EMPNO']=item['IDNO']
                }
            })
        },
        //表格行 按回车键 到下一行
        btnSure(obj){
            if (this.v_key=='EMPNO' ){
                let v_row={EMPNO:obj['IDNO'] ,EMPNM:obj['EMPNM'],BANKNO:obj['BANKNO'],BANKNM:obj['BANKNM'],DEPTNM:obj['DEPTNM'] }
                Object.assign(this.mainRow,v_row)     
                this.btnWin =false
            }else if (this.v_key=='MATNO'  ){
                let v_row={MATNO:obj['IDNO'] ,MATNM:obj['MATNM'],MATDESC:obj['MATDESC']}
                Object.assign(this.mainRow,v_row)     
                this.btnWin =false
            }else if (this.v_key=='MATNO2'  ){
                let v_row={MATNO2:obj['IDNO'] ,MATNM2:obj['MATNM'],MATDESC2:obj['MATDESC']}
                Object.assign(this.mainRow,v_row)     
                this.btnWin =false
            }else if (this.v_key=='MATNO3'  ){
                let v_row={MATNO3:obj['IDNO'] ,MATNM3:obj['MATNM'],MATDESC3:obj['MATDESC']}
                Object.assign(this.mainRow,v_row)     
                this.btnWin =false
            }else if (this.v_key=='MATNO4'  ){
                let v_row={MATNO4:obj['IDNO'] ,MATNM4:obj['MATNM'],MATDESC4:obj['MATDESC']}
                Object.assign(this.mainRow,v_row)     
                this.btnWin =false
            }
            
        },
        inputBtn(row,index, key){ 
            if (key =='MATNO'||key =='MATNO2'||key =='MATNO3'||key =='MATNO4'){    
                this.v_random=Math.random()  
                this.v_key =key  
                this.v_table ='v_BS_MAT'
                this.tableCol =this.prodCol
                this.v_key2 ='modelno'
                this.v_value2 = 'PRD'
                this.t_cond=''
                this.btnWin =true
 
            } 
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'426023',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
 
        dtlAdd(){
 
            this.editWin =true   
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.mainRow =JSON.parse(JSON.stringify( row ))
            this.qryImgData(row['IDSEQ'])
            this.addWin=true   
            this.v_commit =true   
 
        },
        //保存记录
        saveRec(){
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.mainRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit) { 
                this.v_commit =false   
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/formOneSave',
                    data: {p_json:JSON.stringify(Object.assign(this.mainRow,{CORPID:this.v_corpid })), p_table:'SKU_FEE',frmid:'426023'},
                }).then(res=>{      
                    if(res.result ==='OK')  {  
                        let idseq_ =res.idseq
                        //3、图片保存
                        for(var k=0;k<this.imgData.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/tableBodySave',
                                data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                            })
                        }  
                        //图片删除处理
                        for(let k=0;k<this.delImg.length;k++){
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/delTabRec',
                                data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                            })    
                        }
 
                        this.addWin =false   
                        this.getQryList('')
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    }        
                }) 
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.mainRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'N' }
            this.saveFlag=false
            this.v_commit =true
            this.imgData =[]
        },
        //查询附件数据
        qryImgData(idseq){
            this.imgData=[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {              
                if (res){
                    this.imgData =res.result
                }
            })
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.index
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        rowClick(row){
            this.chkIndex =row.index
        },
         //状态变更
        stfgRec(row,val,index,v_comm){ 
            let v_cond ='' ,v_chkdttm='',v_chkuser='',v_cfmdttm='',v_cfmuser=''
            if (val =='P') {
                v_cfmdttm =getDate('full')
                v_cfmuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',payer=\''+v_cfmuser+'\',paydttm=\''+v_cfmdttm+'\''
            }else if (val =='Y'){
                v_chkdttm =getDate('full')
                v_chkuser =this.v_usernm
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else if (val =='K') {
                v_cond =' set stfg=\''+val+'\',appuser=\''+this.v_usernm+'\',appdttm=\''+getDate('full')+'\',chkuser=null,chkdttm=null'
            }else{
                v_chkuser='',v_chkdttm='',v_cfmuser='',v_cfmdttm=''
                v_cond =' set stfg=\''+val+'\',chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\',payer=\''+v_cfmuser+'\',paydttm=\''+v_cfmdttm+'\',appuser=null,appdttm=null'
            }
             
            this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'SKU_FEE',p_cond: v_cond},
                }).then(res=>{      
                    if(res.code =='200')  {  
                        if (val =='X'){
                            this.qcData.splice(index,1)
                        } else{        
                
                            Object.assign(row,{STFGNM:v_comm ,STFG:val, CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
 
                        }
                    }    
                })
            }).catch(()=>{})   
                
        },
 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.qcData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.qcData = this.allList          
            }else{
         
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.qcData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                this.$refs.refreq.doLayout();
            }) 
        },
 
        //查询界面
        getQryList(cond){
            let vm =this
            this.v_loading =true
            getTabColOrData(this.v_url,'V_SKU_FEE','','','CORPID',this.v_corpid,'','',cond +' order by '+this.selparam+' desc').then((res) => { 
                if (res.code=='200'){
                    this.allList =res.result 
                    this.initPage() 
                    this.$nextTick(()=>{
                        this.v_loading =false
                    })
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            })
        },
  
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','426023','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        holder:res.result[k].HOLDER,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.hrCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .item-width  {
        height:22px;
        width: 32%;
    }
    .item-one {
        width: 97%;
        height:88px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>